import {Directive, Input} from '@angular/core';

@Directive({
    selector: '[appHtmlAnchor]',
})
export class HtmlAnchorDirective {
    @Input() public documentId!: number;

    @Input() public documentDpsId!: string;
}
